var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1487_115189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 18,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5909 6.4H18.5455C19.9364 6.4 21 7.44 21 8.8V17.6C21 18.96 19.9364 20 18.5455 20H5.45455C4.06364 20 3 18.96 3 17.6V6.4C3 5.04 4.06364 4 5.45455 4H9.54545C9.79091 4 10.0364 4.16 10.2 4.32L11.5909 6.4ZM18.5456 18.4C19.0365 18.4 19.3637 18.08 19.3637 17.6V8.8C19.3637 8.32 19.0365 8 18.5456 8H11.1819C10.9365 8 10.691 7.84 10.5274 7.68L9.13647 5.6H5.45466C4.96375 5.6 4.63647 5.92 4.63647 6.4V17.6C4.63647 18.08 4.96375 18.4 5.45466 18.4H18.5456Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1487_115189)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#BDBDBD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolder);
export default __webpack_public_path__ + "static/media/ic_folder.dc55e53a3941f2277b9e7eb7c0002616.svg";
export { ForwardRef as ReactComponent };